import { FC, Fragment } from 'react';
import {
    PerformMultiSelect,
    PerformDateRangeFilterSelector,
    PerformNumeric,
    PerformEnumMultiSelect,
    PerformEnumSelect,
    PerformRefdtoMultiSelect,
} from '../perform-indicator/perform-indicator';
import * as Styles from './segment-parts.module.less';
import {
    MembershipFilterDto,
    RecurringServiceEventStatus,
    MembershipStatus,
} from '@servicetitan/application-data/marketing';

interface MembershipProps {
    membership: MembershipFilterDto;
}

export const Membership: FC<MembershipProps> = ({ membership }) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Membership</div>
        <div>
            <PerformMultiSelect name="Membership Name" value={membership.names} />
            <PerformMultiSelect name="Zip Code" value={membership.zipCodes} />
            <PerformMultiSelect name="Membership Tag" value={membership.tags} />
            <PerformMultiSelect name="Recurring Service" value={membership.recurringServices} />
            <PerformDateRangeFilterSelector
                name="Recurring Service Event Date"
                valueStatic={membership.recurringEventDate}
                valueDynamic={membership.recurringEventDateRelative}
            />
            <PerformEnumMultiSelect
                name="Recurring Service Event Status"
                value={membership.recurringEventStatus}
                enumType={RecurringServiceEventStatus}
            />
            <PerformEnumSelect
                name="Membership Status"
                value={membership.status}
                enumType={MembershipStatus}
            />
            <PerformDateRangeFilterSelector
                name="Membership Start Date"
                valueStatic={membership.membershipStartDate}
                valueDynamic={membership.membershipStartDateRelative}
            />
            <PerformDateRangeFilterSelector
                name="Membership End Date"
                valueStatic={membership.membershipEndDate}
                valueDynamic={membership.membershipEndDateRelative}
            />
            <PerformNumeric
                name="Remaining Follow-Ups Events Left"
                value={membership.remainingFollowUps}
            />
            <PerformDateRangeFilterSelector
                name="Next Follow Up"
                valueStatic={membership.nextFollowUpDate}
                valueDynamic={membership.nextFollowUpDateRelative}
            />
            <PerformRefdtoMultiSelect name="Business Unit" value={membership.businessUnits} />
            <PerformDateRangeFilterSelector
                name="Credit Card Expiration Date"
                valueStatic={membership.creditCardExpirationDate}
                valueDynamic={membership.creditCardExpirationDateRelative}
            />
        </div>
    </Fragment>
);
